import css from 'styled-jsx/css';
import { colors, typography } from '../../../config/styles';

const accordionStyle = css`
  .accordion {
    background-color: ${colors.white.shade1};
    max-width: 100vw;
    display: flex;
    flex-direction: column;
    gap: 20px;

    @mixin mobileToTablet {
      margin-bottom: 4rem;
      position: relative;
      gap: 0;
    }
  }
`;

const accordionItemStyle = css`
  li {
    padding: 6px 0;
    list-style-type: none;
    display: flex;
    flex-direction: column;
    gap: 10px;
    @mixin mobileToTablet {
      border-bottom: 1px solid ${colors.gray.shade36};
      border-radius: 3px;
      padding: 0;
      gap: 0;
    }
    &.withBorder {
      border-top: 1px solid ${colors.gray.shade36};
      border-bottom: 0;
      border-radius: 3px;
      background-color: ${colors.gray.shade12};
      padding-top: 8px;
      padding-bottom: 0;
      &.bottomPadding {
        padding-bottom: 8px;
      }
      @mixin tabletToDesktop {
        border-top: 1.1px solid ${colors.gray.shade36};
        border-bottom: 1.1px solid ${colors.gray.shade36};
      }
      &.isCart {
        border: none;
      }
    }
    &.withBorderBottom {
      position: relative;
      &::after {
        content: '';
        display: flex;
        position: absolute;
        bottom: 0;
        left: -14px;
        width: calc(100% + 14px);
      }
      &:last-child {
        &::after {
          display: none;
        }
      }
    }
    button {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      @mixin mobileToTablet {
        padding: 10px 13px 10px 15px;
      }
      .container {
        display: flex;
        align-items: center;
        justify-content: flex-start;

        .logo {
          color: ${colors.green.shade1};
          text-align: center;
          font-size: ${typography.xl2b};
          &.rebranded {
            color: ${colors.gray.shade45};
            .csicon-disponibilidad {
              @mixin mobileToTablet {
                font-size: 2.7rem;
              }
            }
            .csicon-calculator {
              @mixin mobileToTablet {
                font-size: 2.5rem;
              }
            }
          }

          &.withPadding {
            padding-right: 14px;
            padding-left: 22px;
          }
          &.withFixedWidth {
            min-width: 80px;
            width: 80px;
          }
        }
        .headingContainer {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          > * {
            text-align: left;
          }
          &.flexRow {
            flex-direction: row;
            align-items: center;
          }
        }
      }
    }
    .shipping {
      padding-bottom: 4px;
    }
    .icon {
      font-size: ${typography.xxs};
      display: flex;
    }
    div[hidden] {
      display: hidden;
    }
    .mkp-count {
      background: ${colors.gray.shade56};
      border-radius: 15px;
      color: ${colors.black.shade3};
      width: 20px;
      height: 20px;
      text-align: center;
      padding: 1px 0;
      margin-right: 5px;
      margin-left: 5px;
      font-size: 1.2rem;
      font-family: Lato;
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
    }
  }
`;

export { accordionItemStyle, accordionStyle };
